import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalService } from './modal.service';
import {ServiceModule} from '../services/service.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PipesModule} from '../pipes/pipes.module';
import { LaddaModule } from '../../../node_modules/angular2-ladda';
import {EdlModalEvidence} from './edl-evidence-modal.component';
import {EdlModalConfirmNotes} from './edl-modal-confirm-notes/edl-modal-confirm-notes.component';
import {EdlModalSubmit} from './edl-modal-submit.component';
import { EdlModalSendMessage } from './edl-send-message-modal.component';
import { EdlModalDetails } from './edl-modal-details/edl-modal-details.component';
import { EdllModalNotesComponent } from './edl-modal-notes/edl-modal-notes.component';
import { ComponentModule } from '../components/components.module';
import { EdlModalArchiveItem } from './edl-modal-archive-item/edl-modal-archive-item.component';
import { EdlModalDuplicateItem } from './edl-modal-duplicate-item/edl-modal-duplicate-item.component';
import { EdlModalAdvancedRosterSearch } from './edl-advanced-roster-search/edl-modal-advanced-roster-search.component';
import { EdlModalApiResponse } from './edl-modal-api-response/edl-modal-api-response.component';
import { ErrorTailorModule } from '@ngneat/error-tailor';
import { EdlCommonComponentsModule, EdlCommonDirectiveModule, EdlCommonModalModule, EdlCommonPipesModule, EdlDatePickerModule, EdlEntriesModule, EdlModalUserDirectoryModule } from '@edl-development/edl-common';
import { ComplyDirectivesModule } from '../directives/comply-directives.module';
import { EdlToggleRoleModalComponent } from './edl-toggle-role-modal/edl-toggle-role-modal.component';
import { EdlModalRosterPrintComponent } from './edl-modal-roster-print/edl-modal-roster-print.component';
import { FlexUserSubmissionDetailsModalComponent } from './flex/flex-user-details-confirm-modal/flex-user-details-confirm-modal.component';

@NgModule({
    imports: [
        CommonModule,
        EdlCommonModalModule,
        ComponentModule,
        EdlCommonComponentsModule,
        ServiceModule,
        NgbModule,
        FormsModule,
        ReactiveFormsModule,
        EdlCommonDirectiveModule,
        ComplyDirectivesModule,
        EdlCommonPipesModule,
        EdlDatePickerModule,
        PipesModule,
        LaddaModule,
        ErrorTailorModule,
        EdlEntriesModule,
        EdlModalUserDirectoryModule
    ],
    providers: [
        ModalService
    ],
    declarations: [
        EdlModalAdvancedRosterSearch,
        EdlModalApiResponse,
        EdlModalArchiveItem,
        EdlModalEvidence,
        EdlModalConfirmNotes,
        EdlModalDetails,
        EdlModalSubmit,
        EdlModalSendMessage,
        EdllModalNotesComponent,
        EdlModalDuplicateItem,
        EdlToggleRoleModalComponent,
        EdlModalRosterPrintComponent,
        FlexUserSubmissionDetailsModalComponent
    ],
    exports: [
        EdlModalDetails,
        EdlModalApiResponse
    ]
})
export class ModalModule {}